import { render, staticRenderFns } from "./SaleOrderOtherPayment.vue?vue&type=template&id=05041e6e&scoped=true"
import script from "./SaleOrderOtherPayment.vue?vue&type=script&lang=js"
export * from "./SaleOrderOtherPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05041e6e",
  null
  
)

export default component.exports